import { useLayoutEffect } from 'react';

const USER_TERM_RAW_TEXT = `
제 1 조 (목적)
이 약관은 주식회사 다이렉트컴즈(이하 "당사"이라 합니다)가 운영하는 웹사이트 및 어플리케이션(Application, 이하 웹사이트와 어플리케이션을 통칭하여 "다이렉트결혼준비")에서 제공하는 서비스(이하 "서비스"라 합니다)를 이용함에 있어 "당사"와 이용자의 권리 및 의무 및 책임사항을 규정함을 목적으로 합니다.

제 2 조 (정의)
1. "당사"란 서비스를 제공하는 (주)다이렉트컴즈를 말하며, (주)다이렉트컴즈가 중개 및 판매하는 재화 또는 용역(이하 "재화 등"이라 합니다)을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화 등을 거래할 수 있도록 설정한 가상의 영업장인 사이버 몰의 의미로도 사용합니다.
2. "이용자"란 "당사"에 접속하여 이 약관에 따라 "당사"가 제공하는 서비스를 받는 회원을 말합니다.
3. "회원"이라 함은 "당사"에 개인정보를 제공하여 회원등록을 한 자로서,"당사"의 정보를 지속적으로 제공받으며,"당사"가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.
4. “업체"라 함은 당사와 계약을 체결하여 “회원”에게 결혼 관련 상품 및 서비스를 제공하거나 거래할 수 있는 온라인 및 오프라인 법인 또는 개인사업자를 의미합니다. “업체”는 회사 및 업체의 사정에 따라 해지 또는 추가될 수 있습니다.

제 3 조 (약관의 명시와 개정)
1. "당사"는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지, 주소, 전화번호, 전자우편주소, 사업자등록번호, 통신판매업신고번호, 개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 웹사이트의 초기 서비스화면에 게시합니다.
2. "당사"는 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
3. "당사"가 약관을 개정할 경우 적용일자 및 개정내용, 개정사유 등을 명시하여 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 이용자에게 불리하게 변경하는 경우에는 최소 30일 이전의 유예기간을 두고 공지합니다.
4. 개정약관은 적용일자 이후 체결되는 계약에 적용됩니다. 다만 이용자가 개정약관 적용을 원하는 뜻을 공지기간 내에 송신하여 동의를 받은 경우에는 개정일자부터 적용됩니다.
5. 이용자는 개정약관에 동의하지 않을 권리가 있으며, 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴를 요청할 수 있습니다.
6. 이 약관은 서비스 이용 관련 기본약정이며, 특정 서비스에 관한 개별약관이 있는 경우 개별약관이 우선 적용됩니다.
7. 이용자가 가입 시 동의한 약관에 관하여 열람을 요구할 경우, “당사”는 이용자가 가입 시 기재한 전자우편 주소로 링크 형태로 전송합니다.
8. 개별 서비스에 대한 이용약관 등이 본 약관에 우선합니다.
9. 이 약관과 개별약관에 정하지 아니한 사항은 관계법령, 정부기관의 해석 또는 상관례에 따릅니다.

제 4 조 (서비스의 제공 및 변경)
1. "당사"는 직접 판매하는 재화 등에 대한 정보 제공 및 판매계약 체결, 제휴업체와의 용역 이용계약 체결 중개 및 재화 등의 판매계약 중개, 기타 "당사"가 정하는 업무를 수행합니다.
2. 중개 서비스의 경우 “당사”는 판매자인 제휴업체와 이용자 간 거래의 신뢰도 및 안정성을 증진시키는 도구만 제공하며, 거래 관련 책임은 거래 당사자가 부담합니다.
3. "당사"는 재화 또는 용역의 품절, 기술적 사양 변경 등의 경우 제공 내용을 변경할 수 있습니다.
4. 제공하기로 계약한 서비스 내용이 변경될 경우 그 사유를 이용자에게 통지합니다.
5. "당사”는 필요하다고 판단하는 경우 서비스의 일부를 제휴업체 등 제3자에 위탁할 수 있습니다.

제 5 조 (서비스의 중단)
1. "당사"는 정보통신설비의 보수 점검, 교체 및 고장, 통신 두절, 서비스 이용 폭주, 국가비상사태, 정전, 천재지변 등 정상적인 서비스 이용에 지장이 있는 경우 서비스를 일시적으로 중단할 수 있습니다.
2. 사업종목의 전환, 사업 포기, 업체간 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우 "당사”는 제8조에 정한 방법으로 이용자에게 통지합니다.

제 6 조 (회원가입)
1. 이용자는 "당사"가 정한 가입 양식에 따라 회원정보를 기입하고 이 약관에 동의함으로써 회원가입을 신청합니다.
2. "당사"는 가입신청자가 회원자격 상실 이력이 있거나 등록 내용에 허위, 기재누락, 오기가 있거나 기타 기술상 지장이 있다고 판단되는 경우 회원 등록을 거절할 수 있습니다.
3. 회원가입의 성립시기는 "당사"의 승낙이 회원에게 도달한 시점으로 합니다.
4. 회원은 등록사항에 변경이 있는 경우 즉시 전자우편 및 기타 방법으로 “당사”에 알려야 합니다.

제 7 조 (회원 탈퇴 및 자격 상실 등)
1. 회원은 "당사"에 언제든지 탈퇴를 요청할 수 있으며 "당사"는 즉시 회원 탈퇴를 처리합니다.
2. 회원이 허위 등록, 대금 미지급, 타인 이용 방해, 법령 또는 약관 위반, 업무 방해, 타인 정보 도용, 권리 양도, 무단 영업활동, 서비스 위해, 정보 무단 복제·제공, 명예훼손성 또는 음란한 정보 유포, 타인 개인정보 수집 등 사유에 해당하는 경우 "당사"는 회원자격을 제한 또는 정지시킬 수 있습니다.
3. 동일한 행위가 반복되거나 30일 이내 시정되지 않는 경우 "당사"는 회원자격을 상실시킬 수 있습니다.
4. 회원자격을 상실시키는 경우 회원등록을 말소하며, 회원에게 통지하고 소명할 기회를 부여합니다.

제 8 조 (회원에 대한 통지)
1. "당사"가 회원에 대한 통지를 하는 경우 회원이 제출한 전자우편 주소 또는 휴대전화 번호로 할 수 있습니다.
2. 불특정다수 회원에 대한 통지는 1주일 이상 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다.

제 9 조 (게시물의 관리)
1. "당사"는 게시물이 타인 비방, 공공질서 및 미풍양속 위반, 무단 광고, 범죄적 행위, 제3자의 권리 침해, 관계법령 또는 내부 규정 위반에 해당한다고 판단되는 경우 사전 통지 없이 삭제할 수 있습니다.
2. "당사"는 제휴업체 또는 이용자가 게시 정보의 정확성 등을 신뢰함으로써 입은 손해에 대하여 고의·과실이 없는 한 책임을 지지 않습니다.

제 10 조 (정보제공 및 광고)
1. "당사"는 회원이 서비스 이용 중 필요하다고 인정되는 정보를 공지사항, 전자우편, 서신우편, SMS, 알림톡, 전화 등의 방법으로 제공할 수 있습니다.
2. "당사"는 서비스상 광고주의 판촉활동에 이용자가 참여하거나 거래함으로써 발생하는 손실과 손해에 대해 고의·과실이 없는 한 책임을 지지 않습니다.

제 11 조 (대금지급방법)
"당사"에서 구매한 재화 또는 용역에 대한 대금지급은 온라인 무통장 입금, 가상계좌 입금, 실시간 계좌이체, 카드 결제, 전자결제수단, 기타 “당사”가 인정하는 결제수단 중 지정하는 방식으로 이루어집니다.

제 12 조 (손해배상 및 면책)
1. "당사"는 고의·과실로 발생한 손해에 관하여 통상손해를 한도로 배상할 책임이 있습니다.
2. 이용자가 약관을 위반하여 “당사”에 손해가 발생하는 경우 이용자는 통상손해를 한도로 배상할 책임이 있습니다.
3. "당사"는 천재지변, 전쟁, 기간통신 사업자의 서비스 중지, 설비 보수, 이용자 귀책사유, 이용자 컴퓨터 오류, 기대수익 상실, 이용자가 얻은 자료로 인한 손해, 이용자 상호 간 또는 이용자와 제3자 간 분쟁 등에 대해 책임을 지지 않습니다.

제 13 조 (재화 등의 공급)
1. "당사"는 이용자와 별도 약정이 없는 이상 청약일로부터 7일 이내 재화 등을 배송할 수 있도록 필요한 조치를 취합니다.
2. "당사"는 배송수단, 배송비용 부담자, 배송기간 등을 명시합니다.
3. 공휴일, 휴무일, 천재지변 등 불가항력적 사유가 발생하는 경우 해당 기한은 배송소요기간에서 제외합니다.

제 14 조 (환급, 반품 및 교환)
1. 품절 등의 사유로 재화 등을 제공할 수 없을 때에는 지체 없이 사유를 통지하고 대금을 받은 경우 3영업일 이내 환급하거나 필요한 조치를 취합니다.
2. 반품 또는 교환 비용은 귀책사유 있는 측에서 부담합니다.
3. 해외업체 중개판매 상품 또는 용역은 현지업체 정책에 따라 반품, 교환, 환급이 제한될 수 있습니다.

제 15 조 (청약철회 등)
1. 재화 등의 구매계약을 체결한 이용자는 수신확인 통지를 받은 날부터 7일 이내 청약철회를 할 수 있습니다.
2. 이용자 책임으로 재화 등이 훼손된 경우, 사용 또는 소비로 가치가 감소한 경우, 시간이 지나 재판매가 곤란한 경우, 복제 가능한 재화의 포장을 훼손한 경우, 용역 또는 디지털 콘텐츠 제공이 개시된 경우에는 청약철회 및 교환이 제한될 수 있습니다.

제 16 조 (청약철회 등의 효과)
1. "당사"는 재화 등을 반환 받은 경우 3영업일 이내 이미 지급받은 대금을 환급합니다.
2. 신용카드 또는 전자화폐 등 결제수단으로 지급한 경우 해당 사업자에게 청구 정지 또는 취소를 요청합니다.
3. 청약철회 시 반환 비용은 이용자가 부담합니다.
4. "당사"는 청약철회 시 비용 부담 주체를 이용자가 알기 쉽도록 명확하게 표시합니다.

제 17 조 (개인정보취급방침)
개인정보보호에 관한 사항은 “당사”의 홈페이지에 별도로 게재된 개인정보취급방침에 규정된 내용에 따릅니다.

제 18 조 ("당사"의 의무)
1. "당사"는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 안정적으로 서비스를 제공하는 데 최선을 다합니다.
2. "당사"는 이용자가 안전하게 서비스를 이용할 수 있도록 개인정보 보호를 위한 보안시스템을 갖추어야 합니다.

제 19 조 (회원의 ID 및 비밀번호에 대한 의무)
1. ID와 비밀번호 관리책임은 회원에게 있습니다.
2. 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안 됩니다.
3. 도난 또는 제3자 사용을 인지한 경우 즉시 "당사"에 통보하고 안내에 따라야 합니다.

제 20 조 (이용자의 의무)
이용자는 허위 등록, 타인 정보 도용, 게시 정보 변경, 무단 정보 송신, 지적재산권 침해, 명예훼손 또는 업무방해, 음란·폭력적 정보 게시, 이벤트 서비스 부정 사용, 고객불만 처리 절차 중 부적절한 언행, 업체 및 제3자와의 직거래, 법령상 거래 제한 재화 또는 용역 구매 시도 등을 하여서는 안 됩니다.

제 22 조 (연결 "회사"와 피연결 "회사" 간의 관계)
1. 상위 "회사"와 하위 "회사"가 하이퍼 링크 방식 등으로 연결된 경우 전자를 연결 "회사", 후자를 피연결 "회사"라고 합니다.
2. 연결 "회사"는 피연결 "회사"가 독자적으로 제공하는 재화 등에 의한 거래에 대해 보증책임을 진다는 뜻을 명시한 경우에만 보증책임을 집니다.

제 23 조 (회원의 게시물 및 저작권)
1. 게시물은 회원이 서비스를 이용하면서 게시한 글, 사진, 파일, 링크 등을 말합니다.
2. 회원의 게시물에 의한 손해나 기타 문제가 발생하는 경우 회원이 책임을 지며, “당사”는 책임을 지지 않습니다.
3. 회원 게시물의 저작권은 제3자의 권리를 침해하지 않는 한 게시한 회원에게 귀속됩니다. 단, "당사"는 홍보·마케팅 목적을 위해 이를 노출하거나 일부 가공할 수 있습니다.
4. 이용계약 해지 후에도 타인에 의해 재게시되거나 공용 게시판에 등록된 게시물, 홍보 목적으로 재가공 및 노출된 콘텐츠 등은 삭제되지 않습니다.

제 24 조 (분쟁해결)
1. "당사"는 이용자의 정당한 의견이나 불만을 반영하고 피해를 보상처리하기 위하여 관련 법령과 내부 정책에 따라 피해보상처리기구를 설치 또는 운영합니다.
2. 불만사항 및 의견은 우선적으로 처리하기 위해 노력하며, 신속한 처리가 곤란한 경우 사유와 처리일정을 통보합니다.
3. 전자상거래 분쟁과 관련하여 피해구제신청이 있는 경우 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정신청을 안내할 수 있습니다.

제 25 조 (재판권 및 준거법)
1. "당사"와 이용자 간 분쟁에 관한 소송 관할은 서울중앙지방법원으로 하며, 사전 합의가 없는 경우 민사소송법의 관할 규정에 따릅니다.
2. "당사"와 이용자 간 소송에는 대한민국법을 적용합니다.

제 26 조 (특별규정)
이 약관에 명시되지 않은 사항은 전자거래기본법, 전자서명법, 전자상거래 등에서의 소비자보호에 관한 법률 등 기타 관련법령의 규정에 의합니다.

부칙
이 약관은 2022년 8월 1일부터 시행합니다.
`;

function isHeadingLine(line: string) {
  return /^제\s*\d+\s*조/.test(line) || line === '부칙';
}

function TermText({ text }: { text: string }) {
  return (
    <div className="whitespace-pre-wrap break-keep font-sans text-[14px] leading-[1.9] text-[#2E2F33] md:text-[15px]">
      {text.trim().split('\n').map((line, index) => {
        if (line.trim() === '') {
          return <br key={index} />;
        }

        if (isHeadingLine(line.trim())) {
          return (
            <p key={index} className="mt-6 font-bold text-[#17171A] first:mt-0">
              {line}
            </p>
          );
        }

        return <p key={index}>{line}</p>;
      })}
    </div>
  );
}

export default function UserTermPage() {
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div className="min-h-dvh bg-white pt-16">
      <div className="mx-auto max-w-[900px] px-5 py-10 md:px-8 md:py-14">
        <h1 className="mb-8 text-[28px] font-bold text-[#17171A] md:text-[36px]">
          이용약관
        </h1>
        <TermText text={USER_TERM_RAW_TEXT} />
      </div>
    </div>
  );
}
